// extracted by mini-css-extract-plugin
module.exports = {"bb-hero-landing":"bb-hero-landing__Vl5SM"};